import { render, staticRenderFns } from "./PurchaseTicketItem.vue?vue&type=template&id=076652ac&scoped=true"
import script from "./PurchaseTicketItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./PurchaseTicketItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PurchaseTicketItem.vue?vue&type=style&index=0&id=076652ac&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076652ac",
  null
  
)

export default component.exports